import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Auth
import Login from './auth/Login';
import PortalLogin from './portal/PortalLogin';

// Admin pages
import AdminDashboard from './modules/admin/pages/AdminDashboard';
import ComposeNoticeForParents from './modules/admin/pages/ComposeNoticeForParents';
import ComposeNotification from './modules/admin/pages/ComposeNotification';
import CreateFeeStructure from './modules/admin/pages/CreateFeeStructure';
import EcommerceStoreManagement from './modules/admin/pages/EcommerceStoreManagement';
import Transport from './modules/admin/pages/Transport';
import ViewHallTicket from './modules/admin/pages/ViewHallTicket';
import UserManagement from './modules/admin/pages/UserManagement';
import AssignTeacher from './modules/admin/pages/AssignTeacher';
import AdminBookList from  './modules/admin/pages/AdminBookList';
import ClassTimetable from './modules/admin/pages/ClassTimetable';
import AssignStudents from './modules/admin/pages/AssignStudents'; 

// Teacher pages
import Teacherdashboard from './modules/teacher/pages/Teacherdashboard';
import NotificationsToParents from './modules/teacher/pages/NotificationsToParents';
import ResultsOrReportCard from './modules/teacher/pages/ResultsOrReportCard';
import ScheduleOnlineClass from './modules/teacher/pages/ScheduleOnlineClass';
import TeacherClassworkPage from './modules/teacher/pages/TeacherClassworkPage';
import TeacherHomeworkPage from './modules/teacher/pages/TeacherHomeworkPage';
import TeacherAssignmentPage from './modules/teacher/pages/TeacherAssignmentPage';
import TeacherAttendancePage from './modules/teacher/pages/TeacherAttendancePage';
// Parent pages
import JoinLiveClass from './modules/parents/pages/joinliveclass';
import PayFees from './modules/parents/pages/payfees';
import RaiseATicket from './modules/parents/pages/raiseaticket';
import SchoolTimetable from './modules/parents/pages/schooltimetable';
import SeeNotice from './modules/parents/pages/seenotice';
import SeeResults from './modules/parents/pages/seeresults';
import ParentTransport from './modules/parents/pages/transport';
import ExamPage from './modules/parents/pages/ExamPage';
import ParentsDashboard from './modules/parents/pages/ParentsDashboard';
import HomeworkPage from './modules/parents/pages/HomeworkPage';
import ClassworkPage from './modules/parents/pages/ClassworkPage';
import AssignmentPage from './modules/parents/pages/AssignmentPage';
import StudentBookListPage from './modules/parents/pages/StudentBookListPage';  

//super admin
import SuperAdminDashboard from './modules/superadmin/pages/SuperAdminDashboard';
import SuperAdminModulesPage from './modules/superadmin/pages/SuperAdminModulesPage';
// Global style
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  const handleLoginSuccess = (data, navigate) => {
    setUser(data);
    console.log("Login successful, user data:", data);

    if (data.role === 'admin') {
      navigate('/admin-dashboard');
    } else if (data.role === 'teacher') {
     navigate(`/teacher/${data.teacher_id || data.userId}/teacher-dashboard`);

    } else if (data.role === 'parent') {
      navigate('/parent-dashboard');
    }
  };

  const handleLogout = (navigate) => {
    setUser(null);
    localStorage.clear();
    navigate('/');
  };

  return (
    <Router>
      <Routes>
        {/* Auth */}
        <Route path="/" element={<Login />} />
        <Route path="/portal/:role" element={<PortalLogin onLoginSuccess={handleLoginSuccess} />} />

        {/* Admin */}
<Route path="/admin/:adminId/dashboard" element={<AdminDashboard onLogout={handleLogout} />} />
<Route path="/admin/:adminId/compose-notice-parents" element={<ComposeNoticeForParents onLogout={handleLogout} />} />
<Route path="/admin/:adminId/compose-notification" element={<ComposeNotification onLogout={handleLogout} />} />
<Route path="/admin/:adminId/create-fee-structure" element={<CreateFeeStructure onLogout={handleLogout} />} />
<Route path="/admin/:adminId/ecommerce-store" element={<EcommerceStoreManagement onLogout={handleLogout} />} />
<Route path="/admin/:adminId/admin-transport" element={<Transport onLogout={handleLogout} />} />
<Route path="/admin/:adminId/view-hall-ticket" element={<ViewHallTicket onLogout={handleLogout} />} />
<Route path="/admin/:adminId/manage-user" element={<UserManagement onLogout={handleLogout} />} />
<Route path="/admin/:adminId/assign-teacher" element={<AssignTeacher onLogout={handleLogout} />} />
<Route path="/admin/:adminId/manage-booklist" element={<AdminBookList onLogout={handleLogout} />} />
<Route path="/admin/:adminId/class-timetable" element={<ClassTimetable onLogout={handleLogout} />} />
<Route path="/admin/:adminId/assign-students" element={<AssignStudents onLogout={handleLogout} />} />

        
{/* Teacher */}
<Route path="/teacher/:teacherId/teacher-dashboard" element={<Teacherdashboard onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/notifications-parents" element={<NotificationsToParents onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/results-reportcard" element={<ResultsOrReportCard onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/schedule-online-class" element={<ScheduleOnlineClass onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/class-work" element={<TeacherClassworkPage onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/home-work" element={<TeacherHomeworkPage onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/assignment-work" element={<TeacherAssignmentPage onLogout={handleLogout} />} />
<Route path="/teacher/:teacherId/teacher-attendance" element={<TeacherAttendancePage onLogout={handleLogout} />} />

{/* super admin */}
<Route path="/superadmin/:superAdminId/dashboard" element={<SuperAdminDashboard />} />
<Route path="/superadmin/:superAdminId/manage-modules" element={<SuperAdminModulesPage />} />

{/* Parent */}
<Route path="/parent/:studentId/dashboard" element={<ParentsDashboard onLogout={handleLogout} />} />
<Route path="/parent/:studentId/join-live-class" element={<JoinLiveClass onLogout={handleLogout} />} />
<Route path="/parent/:studentId/pay-fees" element={<PayFees onLogout={handleLogout} />} />
<Route path="/parent/:studentId/raise-a-ticket" element={<RaiseATicket onLogout={handleLogout} />} />
<Route path="/parent/:studentId/school-timetable" element={<SchoolTimetable onLogout={handleLogout} />} />
<Route path="/parent/:studentId/see-notice" element={<SeeNotice onLogout={handleLogout} />} />
<Route path="/parent/:studentId/see-results" element={<SeeResults onLogout={handleLogout} />} />
<Route path="/parent/:studentId/parent-transport" element={<ParentTransport onLogout={handleLogout} />} />
<Route path="/parent/:studentId/exam-result" element={<ExamPage onLogout={handleLogout} />} />
<Route path="/parent/:studentId/home-work" element={<HomeworkPage onLogout={handleLogout} />} />
<Route path="/parent/:studentId/class-work" element={<ClassworkPage onLogout={handleLogout} />} />
<Route path="/parent/:studentId/assignment" element={<AssignmentPage onLogout={handleLogout} />} />
<Route path="/parent/:studentId/see-booklist" element={<StudentBookListPage onLogout={handleLogout} />} />

      </Routes>
    </Router>
  );
}

export default App;
